import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const profileSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: () => ({
        url: "user-supplier-detail",
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_USER_PROFILE],
    }),
    
  }),
});

export const { useGetUserProfileQuery } = profileSlice;
